import { styled } from '@mui/material/styles';
import { Box, Typography, Button, Dialog } from '@mui/material';

export const StyledDialog = styled(Dialog)<{ width?: string; height?: string }>(
  ({ width = '600px', height = '347px' }) => ({
    '& .MuiDialog-paper': {
      width,
      minHeight: height,
      maxWidth: 'none',
      overflow: 'hidden',
      borderRadius: '16px',
      padding: '24px',
      background: '#FFFFFF',
      border: '1px solid #D9F1FF',
      boxSizing: 'border-box',
      position: 'relative',
    },
  })
);

export const RelativePositionBox = styled(Box)({
  position: 'relative',
});

export const CloseIcon = styled(Box)({
  position: 'absolute',
  top: 20,
  right: 24,
  fontSize: '24px',
  cursor: 'pointer',
  color: '#75838A',
  '&:hover': {
    color: '#E85E51',
  },
});

export const HeaderBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '16px',
  position: 'relative',
});

export const AlertIcon = styled(Box)({
  width: 24,
  height: 24,
  marginRight: 12,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#E85E51',
  borderRadius: '50%',
  color: '#FFFFFF',
  fontSize: 16,
});

export const TitleTypography = styled(Typography)({
  fontFamily: 'Outfit, Lufga, sans-serif',
  fontSize: '24px',
  fontWeight: 500,
  color: '#0B2330',
  marginLeft: 8,
});

export const SubtitleTypography = styled(Typography)({
  fontFamily: 'Outfit, sans-serif',
  fontSize: '16px',
  fontWeight: 400,
  color: '#555555',
  marginBottom: '8px',
});

export const SubtitleSecondary = styled(Typography)({
  fontFamily: 'Outfit, sans-serif',
  fontSize: '12px',
  fontWeight: 400,
  color: '#75838A',
  marginBottom: '20px',
});

export const ReasonTextArea = styled('textarea')({
  width: '92%',
  minHeight: '100px',
  padding: '12px',
  marginLeft: '30px',
  marginRight: '30px',
  fontFamily: 'Outfit',
  fontSize: '16px',
  border: '1px solid #D9F1FF',
  borderRadius: '8px',
  background: '#FCFEFF',
  resize: 'vertical',
  outline: 'none',
  boxSizing: 'border-box',
  '&:focus': {
    borderColor: 'var(--primary-blue)',
  },
  '&::placeholder': {
    color: '#555555',
  },
});

export const ButtonContainer = styled(Box)({
  display: 'flex',
  gap: '12px',
  marginTop: '30px',
  position: 'absolute',
  bottom: 20,
  left: 36,
});

export const RejectButton = styled(Button)({
  display: 'flex',
  marginLeft: '20px',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '12px 24px',
  gap: '10px',
  width: 93,
  height: 40,
  background: '#E85E51',
  border: '1px solid #E85E51',
  boxShadow: '0px 2px 4px #E2E3E1',
  borderRadius: '8px',
  color: '#FFFFFF',
  fontFamily: 'Outfit',
  fontSize: '16px',
  fontWeight: 500,
  textTransform: 'none',
  '&:hover': {
    background: '#E85E51',
    filter: 'brightness(0.95)',
  },
  '&.Mui-disabled': {
    opacity: 0.5,
  },
});

export const CancelButton = styled(Button)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '12px 24px',
  gap: '10px',
  width: 97,
  height: 40,
  marginLeft: 12,
  background: '#F1F7FF',
  border: '1px solid #DFDFDF',
  boxShadow: '0px 2px 4px rgba(217, 241, 255, 0.6)',
  borderRadius: '8px',
  color: '#75838A',
  fontFamily: 'Outfit',
  fontSize: '16px',
  fontWeight: 500,
  textTransform: 'none',
  '&:hover': {
    background: '#F1F7FF',
  },
});
